import Header from "@arelia-components/layout/Header";
import { ContentBox } from "@arelia-components/ui-atoms/ContentBox";
import Content from "@arelia-components/layout/Content";

export default function Earnings() {
  return (
    <ContentBox>
      <Header title="Earnings" />
      <Content />
    </ContentBox>
  );
}
